import type { FC } from 'react'

import { cn } from '@/lib/utils'
import { NewsletterForm } from '@/components/kit/newsletter-form'
import { Spark } from '@/components/kit/spark'

interface NewsletterBlockProps {
    source: string
    className?: string
}

export const NewsletterBlock: FC<NewsletterBlockProps> = ({ source, className }) => {
    return (
        <aside
            aria-label='The Tuesday Signal newsletter'
            className={cn('grain grain-light relative overflow-hidden rounded-[2rem] bg-ink p-7 text-cream [--grain-opacity:0.25] md:p-12', className)}
        >
            <Spark className='absolute -right-8 -top-8 size-36 text-ember md:size-48' />

            <div className='relative grid gap-8 lg:grid-cols-2 lg:items-end'>
                <div>
                    <p className='font-mono text-[11px] uppercase tracking-[0.16em] text-cream/60'>The Tuesday Signal</p>
                    <p className='mt-3 font-heading text-[clamp(2rem,4vw,3.25rem)] font-bold leading-[0.95] tracking-[-0.035em]'>
                        The forecast, in your inbox before the feed catches up.
                    </p>
                    <p className='mt-3 max-w-md text-base leading-relaxed text-cream/70'>
                        One email a week. Three things worth stealing. No fluff.
                    </p>
                </div>

                <NewsletterForm
                    source={source}
                    tone='dark'
                />
            </div>
        </aside>
    )
}
